import { apiFetch } from './apiFetch';
import type { BoxMechanism, StaffSalaryListItem, StaffSalarySettings } from '@salaries/shared';

export async function listStaffSalarySettings(): Promise<StaffSalaryListItem[]> {
  return apiFetch<StaffSalaryListItem[]>('/salary-settings');
}

export async function getStaffSalarySettings(id: number): Promise<StaffSalarySettings> {
  return apiFetch<StaffSalarySettings>(`/salary-settings/${id}`);
}

export async function updateStaffSalarySettings(
  id: number,
  settings: StaffSalarySettings,
): Promise<StaffSalarySettings> {
  return apiFetch<StaffSalarySettings>(`/salary-settings/${id}`, {
    method: 'PUT',
    body: JSON.stringify(settings),
  });
}

export async function getStaffMechanisms(id: number): Promise<BoxMechanism[]> {
  return apiFetch<BoxMechanism[]>(`/salary-settings/${id}/mechanisms`);
}

export async function updateStaffMechanisms(
  id: number,
  mechanisms: BoxMechanism[],
): Promise<BoxMechanism[]> {
  return apiFetch<BoxMechanism[]>(`/salary-settings/${id}/mechanisms`, {
    method: 'PUT',
    body: JSON.stringify(mechanisms),
  });
}
